export const museumStaffDashboardConstants ={

    GET_MASTER_PREVIEWDASHBOARD_REQUEST: 'GET_MASTER_PREVIEWDASHBOARD_REQUEST',
    GET_MASTER_PREVIEWDASHBOARD_SUCCESS: 'GET_MASTER_PREVIEWDASHBOARD_SUCCESS',
    GET_MASTER_PREVIEWDASHBOARD_FAILURE: 'GET_MASTER_PREVIEWDASHBOARD_FAILURE',
}